import React, { Component } from "react"
import I18n from "../../utils/i18n.js"
import ReactDOM from "react-dom"
import _ from 'underscore'
import RangeSelector from '../../utils/range_selector'
import FacetSelect2 from '../../utils/facet_select2'

export default {
  handleChange() {
    return this.props.onFormChange();
  },

  isChecked(filter, type) {
    return (this.props.filters !== null) && _.contains(this.props.filters[type], filter);
  },

  isDisabled(filter) {
    return (this.props.facets === null) || (this.props.facets[filter] === 0);
  },

  handleSubFormExpand(e) {
    const width = window.innerWidth;
    e.preventDefault();
    $(e.target).toggleClass('subfilter-open');
    const subForm = $(e.target).parents('.sub-form');
    const $toggleTarget = width < 767 ? subForm.find('.all-facets') : subForm.find('.sub-facets');
    const slideDirection = $toggleTarget.is(':visible') ? 'slideUp' : 'slideDown';
    return $toggleTarget
      .velocity('stop')
      .velocity(slideDirection, {
        duration: 250,
        easing: 'easeInOutQuad',
        complete(el) {
          if (!$toggleTarget.is(':visible')) { return $toggleTarget.attr('style', ''); }
        }
      });
  },

  createSubForm(label, mainFacets, subFacets, klass) {
    if (klass == null) { klass = ""; }
    klass += " sub-form form-row";
    const more = I18n.t('search.form_labels.more');
    return <div className={klass}>
        <h5 onClick={this.handleSubFormExpand} className="head-facets form-cell cell-33">{label}</h5>
        <div className='all-facets form-cell'>
          <div className='main-facets'>{mainFacets}</div>
          <div className='sub-facets'>
            {subFacets}
          </div>
        </div>
      </div>;
  },

  createInput(filter) {
    const checked = this.isChecked(filter, 'booleans');
    const disabled = this.isDisabled(filter);
    return <div key={`key_${filter}`} className={`checkboxes${disabled ? ' disabled' : ''}`}>
        <input type='checkbox' ref={filter} key={filter} id={filter} name='boolean' readOnly={true} disabled={disabled} checked={checked} />
        <label htmlFor={filter}>{I18n.t(`search.attributes.${filter}`)}</label>
      </div>;
  },

  createLanguageInput(filter) {
    const checked = this.isChecked(filter, 'languages');
    return <div key={`key_${filter}`} className='checkboxes'>
        <input type='checkbox' className='input--white' ref={filter} key={filter} id={filter} name='language' readOnly={true} checked={checked} />
        <label htmlFor={filter}>{I18n.t(`search.attributes.${filter}`)}</label>
      </div>;
  },

  createSelect2Input(filter, options, multiple, placeholder, cssClasses) {
    if (placeholder == null) { placeholder = ""; }
    if (cssClasses == null) { cssClasses = ''; }
    const value = this.props.filters !== null ? this.props.filters[filter] : undefined;
    return <div key={`select2_${filter}`}>
        <div className="dropdown-wrapper">
          <FacetSelect2
            key={filter}
            ref={filter}
            value={value}
            options={options}
            onChange={() => this.handleChange()}
            multi={multiple}
            placeholder={placeholder}
            className={cssClasses}
          />
        </div>
      </div>;
  },

  createRangeInput(filter, min, max, options, form, extra_class) {
    if (extra_class == null) { extra_class = ''; }
    return <div key={`range_input_${filter}`} className='filters-top'>
        <label>{I18n.t(`search.${filter}`)}</label>
        <RangeSelector ref={filter} key={filter} onChange={this.handleChange} min={min} max={max} options={options} className={extra_class} />
      </div>;
  },

  componentWillReceiveProps(props) {
    if (props.map && (this.state.autocomplete === null)) {
      const self = this;
      return setTimeout(function() {
        const options = {
          types: ['geocode'],
          componentRestrictions: {country: 'fr'}
        };

        const autocomplete = new google.maps.places.Autocomplete(document.getElementById("places-field"), options);
        autocomplete.bindTo('bounds', props.map);
        self.setState({autocomplete});

        return autocomplete.addListener('place_changed', function() {
          let place;
          if (self.state.autocomplete) { place = self.state.autocomplete.getPlace(); }
          if (!place || !place.geometry) { return; }

          if (place.geometry.viewport) {
            return self.props.map.fitBounds(place.geometry.viewport);
          } else {
            return self.props.map.setCenter(place.geometry.location);
          }
        });
      }
      , 1);
    }
  },
  generateAreaInputs() {
    const self = this;

    let area_inputs = ['regions', 'departments'].map(function(filter) {
      const options = self.props.options[filter].map(value => {
        return { value: value.slug, label: value.name }
      });

      const placeholder = I18n.t(`search.placeholders.${filter}`);
      return self.createSelect2Input(filter, options, true, placeholder, 'input--white');
    });

    const area_sub_inputs = []

    _.each(this.props.options['areas'], function(area) {
      const checked = _.contains(self.props.filters && self.props.filters['areas'], area.slug);
      const disabled = self.isDisabled(area.slug);
      return area_sub_inputs.push(<div key={`key_${area.slug}`} className={`checkboxes${disabled ? ' disabled' : ''}`}>
          <input type='checkbox' ref={area.slug} key={area.slug} id={area.slug} name='areas' placeholder={area.name} readOnly={true} disabled={disabled} checked={checked} />
          <label htmlFor={area.slug}>{area.name}</label>
        </div>
      );
    });

    return this.createSubForm(I18n.t('search.form_labels.areas'), area_inputs, area_sub_inputs, 'areas');
  }
};
